var _rect, _g, _circle, _rect2, _rect3, _circle2, _g2, _g3, _circle3, _g4, _circle4, _g5, _g6, _circle5, _g7, _circle6, _g8, _g9, _circle7, _g0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisuPortfolioDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 614,
    height: 319,
    viewBox: "0 0 614 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 614,
    height: 319,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 6.96338,
    width: 23,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 9.96338H613.645",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 39.9634H613.645",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 69.9634H613.645",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 96.9634,
    width: 19,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 99.9634H613.645",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 129.963H613.645",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 156.963,
    width: 19,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 159.963H613.645",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 186.963,
    width: 19,
    height: 7,
    rx: 3.5,
    fill: "#A3BFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 189.963H613.645",
    stroke: "#A3BFFA",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 216.963,
    width: 19,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 219.963H613.645",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 246.963,
    width: 23,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 249.963H613.645",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 279.963H613.645",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 306.963,
    width: 23,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 309.963H613.645",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 107.883,
    cy: 15.4754,
    r: 15.4754,
    fill: "#FC8181"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78.883,
    y: 38.9507,
    width: 58,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 95.883,
    y: 49.9507,
    width: 24,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.402,
    cy: 84.7787,
    r: 10.7655,
    fill: "#F6AD55"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 103.544,
    width: 20,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 114.544,
    width: 50,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 362.545,
    cy: 120.439,
    r: 7.40127,
    fill: "#FBD38D"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 135.84,
    width: 44,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 419.064,
    cy: 174.557,
    r: 4.7099,
    fill: "#F6E05E"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404,
    y: 187.267,
    width: 31,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 198.267,
    width: 55,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 505.187,
    cy: 219.254,
    r: 2.01853,
    fill: "#9AE6B4"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 483,
    y: 229.272,
    width: 45,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 565.743,
    cy: 245.1,
    r: 8.07411,
    fill: "#68D391"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.556,
    y: 261.174,
    width: 45,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 272.174,
    width: 24,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 6.72843,
    transform: "matrix(-1 0 0 1 198 29.204)",
    fill: "#FEB2B2"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 44,
    width: 35,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 613.645,
    height: 318,
    fill: "white",
    transform: "translate(0 0.963379)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 613.645,
    height: 18,
    fill: "white",
    transform: "translate(0 0.963379)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 613.645,
    height: 18,
    fill: "white",
    transform: "translate(0 30.9634)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 613.645,
    height: 18,
    fill: "white",
    transform: "translate(0 60.9634)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 613.645,
    height: 18,
    fill: "white",
    transform: "translate(0 90.9634)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 613.645,
    height: 18,
    fill: "white",
    transform: "translate(0 120.963)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 613.645,
    height: 18,
    fill: "white",
    transform: "translate(0 150.963)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 613.645,
    height: 18,
    fill: "white",
    transform: "translate(0 180.963)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 613.645,
    height: 18,
    fill: "white",
    transform: "translate(0 210.963)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 613.645,
    height: 18,
    fill: "white",
    transform: "translate(0 240.963)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 613.645,
    height: 18,
    fill: "white",
    transform: "translate(0 270.963)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 613.645,
    height: 18,
    fill: "white",
    transform: "translate(0 300.963)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 7,
    fill: "white",
    transform: "translate(244.402 103.544)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 7,
    fill: "white",
    transform: "translate(244.402 114.544)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 7,
    fill: "white",
    transform: "translate(332.545 135.84)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 7,
    fill: "white",
    transform: "translate(389.064 187.267)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 7,
    fill: "white",
    transform: "translate(389.064 198.267)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 7,
    fill: "white",
    transform: "translate(475.188 229.272)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 7,
    fill: "white",
    transform: "translate(535.743 261.174)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 7,
    fill: "white",
    transform: "translate(535.743 272.174)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 7,
    fill: "white",
    transform: "translate(168 43.9326)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisuPortfolioDesktop);
export default __webpack_public_path__ + "static/media/visu_portfolio_desktop.3c662411766da2c22f2729a4f0b35372.svg";
export { ForwardRef as ReactComponent };